import Vue from 'vue'
import App from './App.vue'
import AppC from './AppC.vue'
import AppN from './AppN.vue'
import App3 from './App3.vue'
import AppM from './AppM.vue'
import AppS from './AppS.vue'
import AppB from './AppB.vue'
import WPAPI from 'wpapi'

Vue.config.productionTip = false
Vue.prototype.$wp = new WPAPI({endpoint: 'https://hotel-chris.gr/wp-json'})

new Vue({
  render: h => h(App),
}).$mount('#appNe')


new Vue({
  render: h => h(AppS),
}).$mount('#app1')

new Vue({
  render: h => h(AppC),
}).$mount('#app2')

new Vue({
  render: h => h(AppN),
}).$mount('#app3')

new Vue({
  render: h => h(App3),
}).$mount('#app4')

new Vue({
  render: h => h(AppM),
}).$mount('#app5')

new Vue({
  render: h => h(AppB),
}).$mount('#app7')
